import { TagModel } from '@app/types/TagModel'
import { useClient, useQuery } from '@based/sdk/react'
import { useCallback, useMemo } from 'react'
import { TagSelectionGroup } from '../shared/TagSelectionGroup'
import { useEditContainerClose } from '../shared/useEditContainerClose'

export type HousingFormsEditProps = {
  initiativeId: number
  selectedTags: number[]
}

export const HousingFormsEdit = ({
  initiativeId,
  selectedTags,
}: HousingFormsEditProps) => {
  const closeFromContainer = useEditContainerClose()
  const onClose = closeFromContainer ?? undefined
  if (!onClose) {
    throw new Error(
      'HousingFormsEdit requires `onClose` or an `EditContainer` ancestor',
    )
  }

  const client = useClient()

  const housingFormsQuery = useQuery('list-housing-forms')

  const allTags: TagModel<number>[] = useMemo(
    () =>
      (housingFormsQuery.data ?? []).map(
        (item: { id: number; title: string }) => ({
          key: item.id,
          value: item.title,
        }),
      ),
    [housingFormsQuery.data],
  )

  const saveHousingForms = useCallback(
    (selectedIds: number[]): Promise<boolean> =>
      client.call('edit-initiative', {
        id: initiativeId,
        value: {
          housingForms: selectedIds.map((id) => ({ id })),
        },
      }),
    [client, initiativeId],
  )

  return (
    <TagSelectionGroup
      allTags={allTags}
      selectedIds={selectedTags}
      onClose={onClose}
      onSave={saveHousingForms}
    />
  )
}
